/**
 * @module utils/phaseUtils
 * @description Helpers for mapping image URLs to study phases.
 */

import { PHASES } from "../config/appConfig";

/**
 * Determine which phase an image belongs to based on its URL path.
 * @param {string} imageUrl - Image URL containing a phase folder segment.
 * @returns {string|null} Phase name (e.g. "Baseline") or null if unrecognised.
 */
export const getPhaseFromImageUrl = (imageUrl) => {
  if (!imageUrl) return null;
  if (imageUrl.includes("phase_1/")) return PHASES.PHASE_1;
  if (imageUrl.includes("phase_2/")) return PHASES.PHASE_2;
  if (imageUrl.includes("phase_3/")) return PHASES.PHASE_3;
  return null;
};

/**
 * Group an array of image objects by their phase folder.
 * @param {Array<{imageUrl: string}>} images - Image objects from data.json.
 * @returns {Record<string, Array>} Images keyed by phase name.
 */
export const groupImagesByPhase = (images) => {
  const grouped = {
    [PHASES.PHASE_1]: [],
    [PHASES.PHASE_2]: [],
    [PHASES.PHASE_3]: [],
  };

  images.forEach((image, index) => {
    const phase = getPhaseFromImageUrl(image?.imageUrl);
    if (phase && grouped[phase]) {
      grouped[phase].push({ ...image, originalIndex: index });
    }
  });

  return grouped;
};
